import { useMutation } from "@tanstack/react-query"
import { updateSection } from "../../../api/projects/updateSection"

export const useUpdateSection = () => {

  return useMutation({
    mutationKey: ["updateSection"],
    mutationFn: updateSection
  })
}